import { TranslocoModule } from '@ngneat/transloco';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { SharedUiThemingModule } from '@tcc-mono/shared/ui/theming';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListSearchHeaderComponent } from './list-search-header.component';
import { ReactiveFormsModule } from '@angular/forms';

import {
  faEllipsisVertical as fadEllipsisVertical,
  faFilter as fadFilter,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faEllipsisVertical as falEllipsisVertical,
  faFilter as falFilter,
} from '@fortawesome/pro-light-svg-icons';

import {
  faEllipsisVertical as farEllipsisVertical,
  faFilter as farFilter,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faEllipsisVertical as fatEllipsisVertical,
  faFilter as fatFilter,
} from '@fortawesome/pro-thin-svg-icons';

import {
  faEllipsisVertical as fasEllipsisVertical,
  faFilter as fasFilter,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faEllipsisVertical as fassEllipsisVertical,
  faFilter as fassFilter,
} from '@fortawesome/sharp-solid-svg-icons';

const icons: IconDefinition[] = [
  fadEllipsisVertical,
  falEllipsisVertical,
  farEllipsisVertical,
  fatEllipsisVertical,
  fasEllipsisVertical,
  fassEllipsisVertical,
  fadFilter,
  falFilter,
  farFilter,
  fatFilter,
  fasFilter,
  fassFilter,
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    SharedUiThemingModule
  ],
  declarations: [ListSearchHeaderComponent],
  exports: [ListSearchHeaderComponent]
})
export class ListSearchHeaderModule {
  private readonly _lib: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(...icons);
  }
}
